module.exports = __webpack_public_path__ + "img/angel-3.6526a04f.webp";